import { render, staticRenderFns } from "./CarouselComponent.vue?vue&type=template&id=4a43bed4&scoped=true"
import script from "./CarouselComponent.vue?vue&type=script&lang=js"
export * from "./CarouselComponent.vue?vue&type=script&lang=js"
import style0 from "./CarouselComponent.vue?vue&type=style&index=0&id=4a43bed4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a43bed4",
  null
  
)

export default component.exports